import React, { FunctionComponent, SVGProps } from "react";

export const WheelIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="26"
      viewBox="0 0 26 26"
      width="26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M1.7746 12.25h3.51122c.15147-1.5773.77571-3.01648 1.72934-4.17418L4.53231 5.59297C2.95381 7.39603 1.94194 9.70768 1.7746 12.25Zm2.20942-8.26524C1.67694 6.29203.25 9.47937.25 13c0 7.0416 5.70837 12.75 12.75 12.75 7.0416 0 12.75-5.7084 12.75-12.75C25.75 5.95837 20.0416.25 13 .25c-3.52038 0-6.70753 1.42674-9.01475 3.73353-.00029.00029-.00058.00057-.00086.00086-.00013.00012-.00025.00025-.00037.00037Zm1.60895.54755 2.48285 2.48285c1.1577-.95363 2.59688-1.57787 4.17418-1.72934V1.7746c-2.54232.16734-4.85397 1.17921-6.65703 2.75771ZM13.75 1.7746v3.51122c1.5773.15147 3.0165.77571 4.1742 1.72934l2.4828-2.48285c-1.803-1.5785-4.1147-2.59037-6.657-2.75771Zm7.7177 3.81837-2.4829 2.48285c.9537 1.1577 1.5779 2.59688 1.7294 4.17418h3.5112c-.1673-2.54232-1.1792-4.85397-2.7577-6.65703ZM24.2254 13.75h-3.5112c-.1515 1.5773-.7757 3.0165-1.7294 4.1742l2.4829 2.4828c1.5785-1.803 2.5904-4.1147 2.7577-6.657Zm-3.8184 7.7177-2.4828-2.4829c-1.1577.9537-2.5969 1.5779-4.1742 1.7294v3.5112c2.5423-.1673 4.854-1.1792 6.657-2.7577Zm-8.157 2.7577v-3.5112c-1.5773-.1515-3.01648-.7757-4.17418-1.7294l-2.48285 2.4829c1.80306 1.5785 4.11471 2.5904 6.65703 2.7577ZM4.53231 20.407l2.48285-2.4828c-.95363-1.1577-1.57787-2.5969-1.72934-4.1742H1.7746c.16734 2.5423 1.17921 4.854 2.75771 6.657ZM13 6.75c-3.45178 0-6.25 2.79822-6.25 6.25 0 3.4518 2.79822 6.25 6.25 6.25 3.4518 0 6.25-2.7982 6.25-6.25 0-3.45178-2.7982-6.25-6.25-6.25Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
